module.exports = __webpack_public_path__ + "img/icon-banner-dex-point-dark.62cb139c.svg";